import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute } from '@angular/router';
import { VendorService } from '../../../../features/vendors/services/vendor.service';

@Component({
  selector: 'app-overview',
  standalone: true,
  imports: [
    CommonModule,
    MatInputModule,
    MatSelectModule
  ],
  templateUrl: './overview.component.html',
  styleUrl: '../../vendor-details.component.scss'
})
export class OverviewComponent {
  partnerDetails: any;
  customerId: any;
  vendorDetails: any;

  constructor(
    private vendorService: VendorService,
    private toastr: ToastrService,
    private route: ActivatedRoute,
  ){}

  ngOnInit(){
    this.route.queryParamMap.subscribe(params => {
      this.customerId = params.get('id');
      if (this.customerId) {
        this.getVendorDetailsById(Number(this.customerId))
        }
      });
  }

  getVendorDetailsById(id: any) {
    this.vendorService.fetchVendorById(Number(id)).subscribe({
      next: (data: any) => {
        this.vendorDetails = data;
      },
      error: (error) => {
        this.toastr.error(error?.message);
      },
    });
  }

}
